export { default } from "./GlobalPopup.component";
